import type { ReactNode } from 'react';
import LoadingIcon from './LoadingIcon';
import styles from './BusyLabel.module.scss';

export default function BusyLabel({ busy, children }: { readonly busy: boolean; readonly children: ReactNode }) {
  return <span className={styles.label} data-busy={busy || undefined}>
    <span className={styles.content}>{children}</span>
    {busy && <span className={styles.indicator} aria-hidden="true"><LoadingIcon /></span>}
  </span>;
}
